/*** @jsx React.DOM */

// Dependencies
var Reflux = require('reflux');

// Job actions	
module.exports = Reflux.createActions([
	"toggleApplyPopup",
]);